import { cornerRadius } from "@bug-on/m3-tokens";

export const LIST_TOKENS = {
	oneLineHeight: 56,
	twoLineHeight: 72,
	threeLineHeight: 88,

	leadingSpace: 16,
	trailingSpace: 16,
	topSpace: 8,
	bottomSpace: 8,
	betweenSpace: 16,
	segmentedGap: 2,

	shape: {
		containerShape: cornerRadius.large,
		itemOuterRadius: cornerRadius.large,
		itemInnerRadius: cornerRadius.extraSmall,
		resting: cornerRadius.extraSmall,
		hovered: cornerRadius.medium,
		focused: cornerRadius.large,
		pressed: cornerRadius.large,
		selected: cornerRadius.large,
		dragged: cornerRadius.large,
		disabled: cornerRadius.extraSmall,
	},

	stateLayer: {
		hover: 0.08,
		focus: 0.1,
		pressed: 0.1,
		dragged: 0.16,
		disabled: 0.1,
	},

	leadingIconSize: 24,
	leadingIconExpressiveSize: 20,
	leadingAvatarSize: 40,
	leadingImageWidth: 56,
	leadingImageHeight: 56,
	leadingVideoSmallWidth: 100,
	leadingVideoSmallHeight: 56,
	leadingVideoLargeWidth: 114,
	leadingVideoLargeHeight: 64,

	trailingIconSize: 24,
	trailingIconExpressiveSize: 20,

	focusIndicatorThickness: 3,
	focusIndicatorOffset: -3,

	cssVars: {
		containerBg: "var(--md-sys-color-surface)",
		selectedContainerBg: "var(--md-sys-color-secondary-container)",
		labelText: "var(--md-sys-color-on-surface)",
		selectedLabelText: "var(--md-sys-color-on-secondary-container)",
		supportingText: "var(--md-sys-color-on-surface-variant)",
		overlineText: "var(--md-sys-color-on-surface-variant)",
		trailingText: "var(--md-sys-color-on-surface-variant)",
		leadingIcon: "var(--md-sys-color-on-surface-variant)",
		focusIndicator: "var(--md-sys-color-secondary)",
	},
} as const;
